import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const ReportingRoutes: Routes = [
  {
    path: "reporting",
    loadComponent: () =>
      import("./reporting/reporting.component").then(
        (m) => m.ReportingComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./report-tiers/report-tiers.component").then(
            (m) => m.ReportTiersComponent,
          ),
      },
      {
        path: "list/:id",
        loadComponent: () =>
          import("./report-list/report-list.component").then(
            (m) => m.ReportListComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./report-details/report-details.component").then(
            (m) => m.ReportDetailsComponent,
          ),
      },
    ],
  },
];
